import { render, staticRenderFns } from "./PaymentBox.vue?vue&type=template&id=1973fc47&scoped=true"
import script from "./PaymentBox.vue?vue&type=script&lang=js"
export * from "./PaymentBox.vue?vue&type=script&lang=js"
import style0 from "./PaymentBox.vue?vue&type=style&index=0&id=1973fc47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1973fc47",
  null
  
)

export default component.exports